import {LoadingOutlined, UploadOutlined, UserOutlined} from '@ant-design/icons';
import {Avatar, Button, Spin, Upload} from 'antd';
import ImgCrop from 'antd-img-crop';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo, useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {beforeUploadImage, useUploadAsset} from '@/components/UploadImage/useUploadAsset';

import style from './index.less';

const SIZE = 90;

const UploadImage = ({
  onChange,
  value,
  disabled,
  btnProps,
  btnText,
  className,
  shape,
  avatarProps,
  isCompanyView,
  isLoading
}) => {
  const {t} = useTranslation('common');
  const {props, imageUrl, handleChange, loading} = useUploadAsset(value, onChange);

  const handleBeforeUpload = useCallback((file) => beforeUploadImage(file), []);

  return (
    <ImgCrop rotate>
      <Upload
        {...props}
        disabled={disabled}
        name="avatar"
        listType="picture-card"
        className={classNames(style.avatarUploader, {[style.avatarUploaderRounded]: shape !== 'square'}, className)}
        showUploadList={false}
        beforeUpload={handleBeforeUpload}
        onChange={handleChange}>
        <Avatar
          src={imageUrl}
          icon={(loading || isLoading) ? <Spin indicator={<LoadingOutlined style={{fontSize: SIZE / 2}} spin/>}/> : (isCompanyView ?
            <UploadOutlined/> : <UserOutlined/>)}
          size={SIZE}
          {...avatarProps}
          shape={shape}/>
        {!isCompanyView && <Button
          type="default"
          className={style.buttonUploader}
          loading={loading || isLoading}
          icon={<UploadOutlined/>}
          {...btnProps}
        >
          {loading ? t('loading') : t(btnText)}
        </Button>}
      </Upload>
    </ImgCrop>
  );
};

export default memo(UploadImage);

UploadImage.defaultProps = {
  value: '',
  btnProps: {},
  btnText: 'explore',
};

UploadImage.propTypes = {
  button: PropTypes.bool,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  isCompanyView: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
  shape: PropTypes.string,
  btnProps: PropTypes.object,
  avatarProps: PropTypes.object,
  btnText: PropTypes.string,
};

